<template>
  <div class="user-cta">
    <Icon name="grClockForward" width="36" class="mb-3"/>
    <div class="mb-5">
      <h4 class="user-cta__title">{{ $t('pages.checkins.no_photo_in_stay_title') }}</h4>
      <h5 class="user-cta__subtitle" v-if="Boolean(canPurchaseDuringStay) === false">{{ $t('pages.checkins.no_photo_in_stay_subtitle') }}</h5>
    </div>
     <b-button class="user-cta__action has-icon" variant="primary" :href="contactUrl" target="_blank" v-if="Boolean(canPurchaseDuringStay) === true">
      <Icon name="send" width="24"/>
      {{ $t('pages.checkins.contact_us') }}
    </b-button>
  </div>
</template>

<script>


export default {
  name: "CtaNoPhotosInStay",
  props: {
    eventName: {
      type: String,
      required: true
    },
    picaCode: {
      type: String,
      required: true
    },
    canBuy: {
      type: Boolean,
      default: false
    },
    canPurchaseDuringStay: {
      type: Boolean,
      default: false
    },
  },
}
</script>


<style scoped>

</style>